export function undefinedToNull<T extends Record<string, any>>(val: T) {
    return Object.fromEntries(
        Object.entries(val).map(([key, value]) => [key, value ?? null])
    ) as Required<T>;
}